module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started-w720.6a8163cf.jpg";